import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Grid from "@material-ui/core/Grid"
import styled from "styled-components"
import Typography from "../Typography"
import { ChallengeYourself, MakeADifference, TeamworkIcon } from "../Icons"
import vSpacing from "../../styles/vSpacing"
import breakpoints from "../../styles/breakpoints"

const { H400Semibold } = Typography

const UspIcon = styled.div`
  display: flex;
  margin-bottom: ${vSpacing.baseX2};
  ${breakpoints.md`
    margin-bottom: ${vSpacing.baseX4};
    justify-content: center;
    svg {
        height: 112px;
        width: 112px;
    }
  `};
`

const UspContent = styled.p`
  ${H400Semibold}
  color: ${props => props.theme.colors.black900};
  ${breakpoints.md`
    text-align: center;
    font-size: 20px;
  `};
`

const UspWithIllustration = ({ data, locale }) => {
  const { _rawUsp1, _rawUsp2, _rawUsp3 } = data
  return (
    <Grid container spacing={16}>
      {_rawUsp1 && (
        <Grid item xs={12} md={4}>
          <UspIcon>
            <ChallengeYourself height="56" width="56" margin="0" />
          </UspIcon>
          <UspContent>{_rawUsp1[locale]}</UspContent>
        </Grid>
      )}
      {_rawUsp2 && (
        <Grid item xs={12} md={4}>
          <UspIcon>
            <MakeADifference height="56" width="56" margin="0" />
          </UspIcon>
          <UspContent>{_rawUsp2[locale]}</UspContent>
        </Grid>
      )}
      {_rawUsp3 && (
        <Grid item xs={12} md={4}>
          <UspIcon>
            <TeamworkIcon height="56" width="56" margin="0" />
          </UspIcon>
          <UspContent>{_rawUsp3[locale]}</UspContent>
        </Grid>
      )}
    </Grid>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query companyInfoForUspRow {
        sanityCompanyInfo {
          _rawUsp1
          _rawUsp2
          _rawUsp3
        }
      }
    `}
    render={data => (
      <UspWithIllustration data={data.sanityCompanyInfo} {...props} />
    )}
  />
)
